import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex grow justify-center" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]

import { ArrowNarrowLeftIcon, ArrowNarrowRightIcon } from '@heroicons/vue/outline';
import { computed, reactive } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    position: null,
    currentPage: null,
    lastPage: null
  },
  emits: ["update:page"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:page', page: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  position: 'top' | 'bottom'
  currentPage: number
  lastPage: number
}





const nearPages = 2;

const previousPagesCount = computed(() => {
  if (props.currentPage > 2 && props.lastPage - props.currentPage > 2) {
    return Math.min(2, props.currentPage - 2);
  }
  
  if (props.lastPage - props.currentPage <= 2) {
    return Math.min(props.lastPage - 2, 5) - props.lastPage + props.currentPage;
  }
  
  return 0;
});

const nextPagesCount = computed(() => {
  if (props.lastPage - props.currentPage > 1 && props.currentPage > 2) {
    return Math.min(2, props.lastPage - props.currentPage - 1);
  }
  
  if (props.currentPage <= 2) {
    return Math.min(props.lastPage - 1, 5) - props.currentPage;
  }
  
  return 0;
});

function getPreviousPageNumber(n) {
  return props.currentPage - previousPagesCount.value + n - 1;
}

function handleNextPageClick() {
  emit('update:page', props.lastPage > props.currentPage ? props.currentPage + 1 : 1);
}

function handlePreviousPageClick() {
  emit('update:page', props.currentPage > 1 ? props.currentPage - 1 : props.lastPage);
}

const classes = reactive({
  root: ['select-none', 'lg:mx-3', 'overflow-x-auto', 'overflow-y-hidden'],
  row: ['flex', 'flex-row', 'gap-6', '-mb-px'],
  number: {
    default: ['py-3', 'lg:px-5', 'px-4', 'font-bold'],
    active: ['text-teal-600', 'border-teal-600'],
    inactive: ['cursor-pointer', 'hover:border-teal-600', 'border-transparent'],
  },
  arrow: {
    previous: ['flex-ro'],
    next: ['flex-row-reverse'],
    default: ['group', 'lg:flex', 'hidden', 'flex-row', 'flex-none', 'gap-4', 'items-center', 'cursor-pointer', 'w-50'],
    text: ['py-3', 'border-transparent', 'group-hover:border-teal-600', 'cursor-pointer', 'flex-none'],
    icon: ['flex-none', 'my-3', 'w-5', 'h-5'],
  },
  position: {
    top: {
      link: ['border-b-2'],
      root: ['border-b'],
    },
    bottom: {
      link: ['border-t-2'],
      root: ['border-t'],
    },
  },
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([..._unref(classes).root, ...(__props.position === 'top' ? _unref(classes).position.top.root : _unref(classes).position.bottom.root)])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_unref(classes).row)
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([..._unref(classes).arrow.default, ..._unref(classes).arrow.previous])
      }, [
        _createVNode(_unref(ArrowNarrowLeftIcon), {
          class: _normalizeClass([..._unref(classes).arrow.icon])
        }, null, 8, ["class"]),
        _createElementVNode("div", {
          class: _normalizeClass([
            ..._unref(classes).arrow.text,
            ...(__props.position === 'top' ? _unref(classes).position.top.link : _unref(classes).position.bottom.link)
          ]),
          onClick: handlePreviousPageClick
        }, _toDisplayString(__props.currentPage === 1 ? 'К последней' : 'Предыдущая'), 3)
      ], 2),
      _createElementVNode("div", _hoisted_1, [
        (__props.currentPage > 1)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass([
            ..._unref(classes).number.default,
            ...(__props.position === 'top' ? _unref(classes).position.top.link : _unref(classes).position.bottom.link),
            ..._unref(classes).number.inactive
          ]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:page', 1)))
            }, " 1 ", 2))
          : _createCommentVNode("", true),
        (__props.currentPage > 4 && __props.lastPage > 5)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass([..._unref(classes).number.default])
            }, " ... ", 2))
          : _createCommentVNode("", true),
        (_unref(previousPagesCount) > 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_unref(previousPagesCount), (n) => {
              return (_openBlock(), _createElementBlock("div", {
                key: n,
                class: _normalizeClass([
              ..._unref(classes).number.default,
              ...(__props.position === 'top' ? _unref(classes).position.top.link : _unref(classes).position.bottom.link),
              ..._unref(classes).number.inactive
            ]),
                onClick: ($event: any) => (emit('update:page', getPreviousPageNumber(n)))
              }, _toDisplayString(getPreviousPageNumber(n)), 11, _hoisted_2))
            }), 128))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass([
            ..._unref(classes).number.default,
            ...(__props.position === 'top' ? _unref(classes).position.top.link : _unref(classes).position.bottom.link),
            ..._unref(classes).number.active
          ])
        }, _toDisplayString(__props.currentPage), 3),
        (__props.currentPage < __props.lastPage)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_unref(nextPagesCount), (n) => {
              return (_openBlock(), _createElementBlock("div", {
                key: n,
                class: _normalizeClass([
              ..._unref(classes).number.default,
              ...(__props.position === 'top' ? _unref(classes).position.top.link : _unref(classes).position.bottom.link),
              ..._unref(classes).number.inactive
            ]),
                onClick: ($event: any) => (emit('update:page', n + __props.currentPage))
              }, _toDisplayString(n + __props.currentPage), 11, _hoisted_3))
            }), 128))
          : _createCommentVNode("", true),
        (__props.lastPage - __props.currentPage >= 4 && __props.lastPage > 5)
          ? (_openBlock(), _createElementBlock("div", {
              key: 4,
              class: _normalizeClass([..._unref(classes).number.default])
            }, " ... ", 2))
          : _createCommentVNode("", true),
        (__props.lastPage - __props.currentPage > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 5,
              class: _normalizeClass([
              ..._unref(classes).number.default,
              ...(__props.position === 'top' ? _unref(classes).position.top.link : _unref(classes).position.bottom.link),
              ..._unref(classes).number.inactive
            ]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('update:page', __props.lastPage)))
            }, _toDisplayString(__props.lastPage), 3))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass([..._unref(classes).arrow.default, ..._unref(classes).arrow.next])
      }, [
        _createVNode(_unref(ArrowNarrowRightIcon), {
          class: _normalizeClass([..._unref(classes).arrow.icon])
        }, null, 8, ["class"]),
        _createElementVNode("div", {
          class: _normalizeClass([..._unref(classes).arrow.text, ...(__props.position === 'top' ? _unref(classes).position.top.link : _unref(classes).position.bottom.link)]),
          onClick: handleNextPageClick
        }, _toDisplayString(__props.currentPage === __props.lastPage ? 'К первой' : 'Следующая'), 3)
      ], 2)
    ], 2)
  ], 2))
}
}

})